import Vue from 'vue'
import VueRouter from 'vue-router'
import zh from '@/views/zh.vue';
import en from '@/views/en.vue';
import zhUser from '@/views/zhUser.vue';
import enUser from '@/views/enUser.vue';
import sdk from '@/views/sdk.vue';
// import ja from '@/views/ja.vue';
// import ko from '@/views/ko.vue';
// import pt from '@/views/pt.vue';
// import es from '@/views/es.vue';
// import de from '@/views/de.vue';
// import ru from '@/views/ru.vue';
// import fr from '@/views/fr.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/enPrivacy',
		component: en,
		meta: {
			title: 'Wi6te Privacy Policy'
		}
	},
	{
		path: '/enPrivacy',
		name: 'enPrivacy',
		component: en,
		meta: {
			title: 'Wi6te Privacy Policy'
		}
	},
	{
		path: '/privacy',
		name: 'privacy',
		component: zh,
		meta: {
			title: 'Wi6te 隐私协议'
		}
	},
	{
		path: '/enUserprotocol',
		name: 'enUserprotocol',
		component: enUser,
		meta: {
			title: 'Wi6te UserProtocol'
		}
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: zhUser,
		meta: {
			title: 'Wi6te 用户协议'
		}
	},
	{
		path: '/sdk',
		name: 'sdk',
		component: sdk,
		meta: {
			title: '附件—第三方SDK说明'
		}
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
